import { useState } from "react";
import { ScanText } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export function useAutoScan() {
  return useState(false);
}

export function AutoScanToggle({ on, onChange, testid }) {
  return (
    <label className="inline-flex items-center gap-2 text-xs cursor-pointer select-none" title="Read text from photos & PDFs on this device and auto-fill the note">
      <Switch checked={on} onCheckedChange={onChange} data-testid={testid} />
      <ScanText className="h-3.5 w-3.5" />AI Scan & auto-fill
    </label>
  );
}
